var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{staticClass:"mb-2",attrs:{"label":"textHint","dense":"","hide-details":""},on:{"change":_vm.toggleTextHint},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}}),(_vm.enabled)?_c('DevContainerOfPanel',{attrs:{"schema":{
      type: 'devContainerOfPanel',
      model: 'textHint',
      component: 'dev-simple-object-attr',
      styleClasses: 'col-12',
      title: 'text Hint'
    },"model":{ textHint: _vm.model.textHint }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }